"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TicketStatus = _interopRequireDefault(require("../TicketStatus"));
var _constants = require("../TicketStatus/constants");
var _Checkbox = _interopRequireDefault(require("../../../Checkbox"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var StyledFilter = _styledComponents["default"].ul.withConfig({
  displayName: "TicketFilterByStatus__StyledFilter",
  componentId: "sc-h9oyxs-0"
})([""]);
var TicketFilterByStatus = function TicketFilterByStatus(_ref) {
  var statuses = _ref.statuses,
    _ref$closedReasonStat = _ref.closedReasonStatuses,
    closedReasonStatuses = _ref$closedReasonStat === void 0 ? [] : _ref$closedReasonStat,
    closedReasonValue = _ref.closedReasonValue,
    closedReasonName = _ref.closedReasonName,
    onClear = _ref.onClear,
    value = _ref.value,
    name = _ref.name,
    onChange = _ref.onChange;
  var isClosedStatusChecked = (0, _react.useMemo)(function () {
    return Array.isArray(value) && value.includes('closed');
  }, [value]);
  var clearClosedReasonFilter = (0, _react.useCallback)(function () {
    onClear(closedReasonName);
  }, [onClear, closedReasonName]);
  (0, _react.useEffect)(function () {
    if (!isClosedStatusChecked) {
      clearClosedReasonFilter();
    }
  }, [isClosedStatusChecked]);
  return /*#__PURE__*/_react["default"].createElement(StyledFilter, null, statuses.map(function (_ref2) {
    var priority = _ref2.priority,
      status = _ref2.value;
    var isChecked = Array.isArray(value) && value.includes(status);
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: status
    }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
      checked: isChecked,
      onChange: onChange,
      name: name,
      value: status
    }, /*#__PURE__*/_react["default"].createElement(_TicketStatus["default"], {
      priority: priority,
      title: status,
      placement: _constants.TICKET_STATUS_PLACEMENT.FILTERS
    })));
  }), isClosedStatusChecked && closedReasonStatuses.map(function (_ref3) {
    var status = _ref3.value,
      title = _ref3.title;
    var isChecked = Array.isArray(closedReasonValue) && closedReasonValue.includes(status);
    return /*#__PURE__*/_react["default"].createElement(StyledClosedReasonCheckBoxContainer, {
      key: status
    }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
      checked: isChecked,
      onChange: onChange,
      name: closedReasonName,
      value: status
    }, /*#__PURE__*/_react["default"].createElement("span", null, title)));
  }));
};
var StyledClosedReasonCheckBoxContainer = _styledComponents["default"].li.withConfig({
  displayName: "TicketFilterByStatus__StyledClosedReasonCheckBoxContainer",
  componentId: "sc-h9oyxs-1"
})(["margin-left:20px;span{margin-left:4px;}"]);
var _default = exports["default"] = TicketFilterByStatus;